/*
|--------------------------------------------------------------------------
| Video: Brightcove
|--------------------------------------------------------------------------
*/
/**
 * Brightcove Video
 * @namespace
 */
__gh__webApp.video.brightcove = {

	"init": function(){
		this.loadLibrary();
	},

	"loadLibrary": function() {
		__gh__webApp.common.loadScript({"src": "http://admin.brightcove.com/js/BrightcoveExperiences.js"});
	},


	"loadPlayerJS": function(options) {
		var player,
			modVP,
			modExp,
			modCon,
			previousVideoID	= 0,
			nextVideo		= 0,
			videos 			= (options.videos) ? new Array(options.videos) : new Array([]);

		function myTemplateLoaded(experienceID) {
			player = brightcove.api.getExperience(experienceID);
			modVP = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
			modExp = player.getModule(brightcove.api.modules.APIModules.EXPERIENCE);
			modCon = player.getModule(brightcove.api.modules.APIModules.CONTENT);
			modExp.addEventListener(brightcove.api.events.ExperienceEvent.TEMPLATE_READY, onTemplateReady);
		}
		function onTemplateReady(evt) {
			modVP.loadVideoByID(videos[nextVideo]);
			modVP.addEventListener(brightcove.api.events.MediaEvent.COMPLETE, onMediaComplete);
			modVP.addEventListener(brightcove.api.events.MediaEvent.CHANGE, onMediaChange);
			modVP.addEventListener(brightcove.api.events.MediaEvent.PLAY, onMediaEventFired);
		}
		function onMediaEventFired(evt) {
			vidplayed = true;
		}
		function onMediaComplete() {
			nextVideo++;
			if (nextVideo==videos.length) {
				nextVideo=0;
			}
			modVP.loadVideoByID(videos[nextVideo]);
		}
		function onMediaChange(evt) {
			document.getElementById("mediaInfoTitle").innerHTML = '<a href="/section?template=videodetail&vid='+evt.media.id+'&vidtitle='+evt.media.displayName+'">'+evt.media.displayName+'</a>';
			var currPubDate = ''+evt.media.publishedDate+'';
			var theCurrMatch = currPubDate.replace(/(\w+)\s(\w+)\s(\d+)\s(\d+)\s(\d+):(\d+):(\d+)\s(\w+)-(\d+)\s(.+)/,'$2 $3, $4');
		}
	}

};
